import { render } from "./FixedServices.vue?vue&type=template&id=46c38484"
import script from "./FixedServices.vue?vue&type=script&lang=js"
export * from "./FixedServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__